import { ReactElement } from 'react'
import { GetStaticPropsContext, InferGetStaticPropsType } from 'next'

import Meta from '@/components/base/meta'
import PageBuilder from '@/components/layout/builder'
import Layout from '@/components/layout/layout'
import { getPromiseFromFetch } from '@/utils/request'
import { MOCK_DATA } from '@/constants'

import { WPPageData } from '@/types'

export default function Home(
  pageProps: InferGetStaticPropsType<typeof getStaticProps>
) {
  return <PageBuilder pageProps={pageProps} />
}

Home.getLayout = function getLayout(page: ReactElement, pageProps: WPPageData) {
  return (
    <Layout pageProps={pageProps}>
      <Meta pageProps={pageProps} />
      {page}
    </Layout>
  )
}

export async function getStaticProps(
  // eslint-disable-next-line no-unused-vars
  { locale, defaultLocale }: GetStaticPropsContext<{ routes: string[] }>
) {
  if (locale === 'default') return { notFound: true }

  const { data: pageProps } = MOCK_DATA
    ? { data: require(`@/data/pages/homepage.json`) }
    : await getPromiseFromFetch<WPPageData>({
        method: 'get',
        url: `/${locale !== defaultLocale ? locale : ''}`
      })

  return {
    props: {
      ...pageProps
    }
  }
}
